import { Building2, Warehouse, Factory, Wrench, Briefcase, Building } from 'lucide-react';
import React from "react" ; 

import { useEffect, useState } from "react";
import SideDrawer from "./sideDrawer";
import Send from '../../../../../_asset/img/send-2.svg';
import JobStreetView from "../../offers/status/jobStreetView";

import ProgressCircle from '../utils/ProgressCircle';

const UnassignedListView = ({ data , getDeadlineText }) => {
    const [open, setOpen] = useState(false);
    const [getByItem, setGetByItem] = useState(null);
    const [selectedJob, setSelectedJob] = useState(null); 

    useEffect(() => {
        if(!open){
            setGetByItem(null);
        }
    }, [open]);

    function getFacilityIcon(facilityType, fallbackSeed) {
        // Map facility types to Material UI icons
        const facilityIcons = {
          workplace: Briefcase,
          warehouse: Warehouse,
          office: Building2,
          factory: Factory,
          construction: Wrench
        };
      
        // Convert the keys of facilityIcons to an array
        const availableTypes = Object.keys(facilityIcons);
      
        // If the facilityType exists, use it; otherwise, choose a consistent icon based on seed
        let SelectedIcon;
        if (facilityIcons[facilityType]) {
          SelectedIcon = facilityIcons[facilityType];
        } else {
          // Use a deterministic approach instead of random - use the fallbackSeed to get consistent icon
          const index = Math.abs((fallbackSeed || 'default').split('').reduce((a, b) => a + b.charCodeAt(0), 0)) % availableTypes.length;
          SelectedIcon = facilityIcons[availableTypes[index]];
        }
      
        // Return the icon component or default icon
        return SelectedIcon || Building;
    }



    return (
        <div className="font-inter">
            <table className="w-full border-separate" style={{ borderSpacing: '0 16px' }}>
                <thead>
                    <tr>
                        <th className="text-sm font-normal text-gray-600 border-0 px-3 text-left">Location</th>
                        <th className="text-sm font-normal text-gray-600 border-0 px-3 text-left">Fulfillment Deadline</th>
                        <th className="text-sm font-normal text-gray-600 border-0 px-3 text-left">Shift Coverage</th>
                        <th className="text-sm font-normal text-gray-600 border-0 px-3 text-left">Active Offers</th>
                        <th className="text-sm font-normal text-gray-600 border-0 px-3 text-left"></th>
                    </tr>
                </thead>                <tbody id="data-body">
                    {data.length > 0 &&
                        data.map((job, index) => {
                            const deadlineText = getDeadlineText(job?.shifts);
                            const percent = job?.statistics.overallCoverage;
                            const color = percent === 100 ? '#52c41a' : '#3385ff';

                            return (
                                <React.Fragment key={job._id || index}>
                                    <tr className="bg-white">
                                        <td className="p-3 border-0 rounded-l-lg align-middle">
                                            <div className="flex items-center gap-2">
                                                <div className="profile">
                                                    <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-primary/10 via-brand-blue-light/30 to-white border border-primary/20 shadow-lg flex items-center justify-center group hover:shadow-xl hover:shadow-brand-pink/20 transition-all duration-300 hover:scale-105 hover:rotate-3">
                                                        <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-transparent to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                        {React.createElement(getFacilityIcon(
                                                            job?.isLead ? 'lead' : job.customer_company_id?.facilityType, 
                                                            job._id || (job?.isLead ? job?.contact?.name : job.customer_company_id?.companyFriendlyName) || 'default'
                                                        ), {
                                                            className: "relative z-10 w-7 h-7 text-primary group-hover:text-brand-pink transition-all duration-300 group-hover:scale-110",
                                                            style: { 
                                                                filter: 'drop-shadow(0 2px 4px rgba(64, 72, 128, 0.15))'
                                                            }
                                                        })}
                                                    </div>
                                                </div>
                                                <div>
                                                    <h4 className="text-base font-medium text-black mb-0.5">
                                                        {job?.isLead 
                                                            ? job?.contact?.name || "Unknown Contact"
                                                            : job.customer_company_id?.companyFriendlyName || "Unknown Company"
                                                        }
                                                    </h4>
                                                    <p className="text-sm font-normal text-gray-500 m-0">{job.formattedAddress}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="p-3 border-0 align-middle">
                                            <p className="font-medium m-0">{deadlineText}</p>
                                        </td>                        <td className="p-3 border-0 align-middle">
                            <ProgressCircle 
                              percent={parseInt(percent.toFixed(0))} 
                              strokeColor={color}
                              size={40}
                            />
                        </td>
                                        <td className="p-3 border-0 align-middle">
                                            <p className="font-medium m-0">{job?.statistics?.validOffersCount || 0}</p>
                                        </td>
                                        <td className="p-3 border-0 rounded-r-lg align-middle">
                                            <span
                                                className="w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center cursor-pointer"
                                                onClick={() => {
                                                    setOpen(true);
                                                    setSelectedJob(job);
                                                }}
                                            >
                                                <img src={Send} alt="" />
                                            </span>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            );
                        })}
                </tbody>
            </table>

            {/* Render the SideDrawer outside the map to prevent re-renders */}
            {selectedJob && open && (
                <SideDrawer
                    job={selectedJob}
                    isOpen={open}
                    setIsOpen={(state) => {
                        setOpen(state);
                        if (!state) setSelectedJob(null); // Close the drawer and reset selected job
                    }}
                    getByItem={selectedJob}
                />
            )}
        </div>
    )
};

export default UnassignedListView;